var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagsnpeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.9C16.66 6.9 17.6 7.84 17.6 9C17.6 10.16 16.66 11.1 15.5 11.1C14.34 11.1 13.4 10.16 13.4 9C13.4 7.84 14.34 6.9 15.5 6.9ZM15.5 15.9C18.47 15.9 21.6 17.36 21.6 18V19.1H9.4V18C9.4 17.36 12.53 15.9 15.5 15.9ZM15.5 5C13.29 5 11.5 6.79 11.5 9C11.5 11.21 13.29 13 15.5 13C17.71 13 19.5 11.21 19.5 9C19.5 6.79 17.71 5 15.5 5ZM15.5 14C12.83 14 7.5 15.34 7.5 18V21H23.5V18C23.5 15.34 18.17 14 15.5 14Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.375V7.25H8.25V5H7.125V7.25H4.875V5H3.75V7.25H1.5V8.375H3.75V10.625H1.5V11.75H3.75V14H4.875V11.75H7.125V14H8.25V11.75H10.5V10.625H8.25V8.375H10.5ZM7.125 10.625H4.875V8.375H7.125V10.625Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsnpeople);
export default __webpack_public_path__ + "static/media/tagsnpeople.ab4d619b.svg";
export { ForwardRef as ReactComponent };